import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import getPresentersFromSeatingOrder from '../getPresentersFromSeatingOrder'
import { StructuredPresenterInterface } from '../structuredSelectPresenter/types'
import { OBSERVER } from '../../constants/roles'


/**
 * Returns an the details of the currently focused presenter
 * @param state The Redux state
 */

const getFocusedPresenter = (state: State): string | null => {
  if (!state.syncUi.autoSpotlight) return state.room.focusOn
  return state.syncUi.dominantSpeaker
}
const getParticipants = (state: State): StructuredPresenterInterface[] => getPresentersFromSeatingOrder(state).filter(res => res.role !== OBSERVER)

export default createSelector(
  [getFocusedPresenter, getParticipants],
  (focusedPresenterId, participants) => participants.find(participant =>
    focusedPresenterId !== null && participant.BTID === focusedPresenterId) || participants[ 0 ])
